/**
 * Copyright (C) 2021 Tencent.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import MenuBase from '@/toolbars/MenuBase';
import { handleUpload, handleUploadMulti } from '@/utils/file';
/**
 * 插入pdf
 */
export default class File extends MenuBase {
  constructor($cherry) {
    super($cherry);
    this.setName('file', 'phone');
  }

  /**
   * 响应点击事件
   * @param {string} selection 被用户选中的文本内容
   * @returns {string} 回填到编辑器光标位置/选中文本区域的内容
   */
  onClick(selection, shortKey = '') {
    const accept = this.$cherry.options?.fileTypeLimitMap?.file ?? '*';
    const multiple = this.$cherry?.options.multipleFileSelection?.file ?? false;
    if (multiple) {
      if (this.hasCacheOnce()) {
        // @ts-ignore
        const arr = this.getAndCleanCacheOnce();
        let res = '';
        // @ts-ignore
        for (const { url, params } of arr) {
          const begin = '[';
          const end = `](${url})`;
          this.registerAfterClickCb(() => {
            this.setLessSelection(begin, end);
          });
          const finalName = params.name ? params.name : name;
          res += `${begin}${finalName}${end}\n`;
        }
        return res;
      }
      // 插入图片，调用上传文件逻辑
      handleUploadMulti(this.editor, 'file', accept, (arr) => {
        this.setCacheOnce(arr);
        this.fire(null);
      });
      this.updateMarkdown = false;
      return selection;
    }
    if (this.hasCacheOnce()) {
      // @ts-ignore
      const { name, url, params } = this.getAndCleanCacheOnce();
      const begin = '[';
      const end = `](${url})`;
      this.registerAfterClickCb(() => {
        this.setLessSelection(begin, end);
      });
      const finalName = params.name ? params.name : name;
      return `${begin}${finalName}${end}`;
    }
    // 插入图片，调用上传文件逻辑
    handleUpload(this.editor, 'file', accept, (name, url, params) => {
      this.setCacheOnce({ name, url, params });
      this.fire(null);
    });
    this.updateMarkdown = false;
    return selection;
  }
}
